import lightGallery from 'lightgallery';
import lgThumbnail from 'lightgallery/plugins/thumbnail'
import lgZoom from 'lightgallery/plugins/zoom'

$(function(){

  $('.enable-gallery').each(function(){

    var $this = $(this);

    lightGallery($this[0], {
      plugins: [lgZoom, lgThumbnail],
      speed: 500,
      selector: '.enable-gallery-item',
      exThumbImage: 'data-thumbnail',
      download: false,
      share: false,
      rotate: false,
    });


  });

});



// WEBPACK FOOTER //
// ./scripts/autoload/_enablegallery.js